import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchRegions, fetchBatchData } from 'thunks/trainingThunks/thunk';
import { fetchDailyEmployeesWhoJoined } from 'thunks/trainingThunks/thunk'; // Import your new thunk
import rootAxios from 'requests/rootAxios';

const initialState = {
  // batchName: null,
  // startDate: null,
  // endDate: null,
  dates: [],
  datesEnd: [],
  ho: null,
  region: [],
  trainer: null,
  batchType: null,
  duration: null,
  description: null,
  address: null,
  venue: null,
  trainingLink: null,
  googleMapsLink: null,
  active: null,
  isApproved: false,
  batchTrainees: [],
  step1Validated: false,
  step2Validated: false,
  step3Validated: false,
  activeTab: 0,
  success: false,
  error: null,
  availableRegions: [],
  batchId: '',
  allAvailableTrainees: [],
  currentlyAssignedTrainees: [],
  trainingType: null,
  availableBranches: [],
  updating: false,
  branch: [],
  trainingRoLocation: null,
  emailConfig: {
    totalSteps: 3,
    steps: [
      { to: [], cc: [] },
      { to: [], cc: [] },
      { to: [], cc: [] },
    ],
  },
  updatedLogDocumentId: null,
};

const trainingSlice = createSlice({
  name: 'trainingSlice',
  initialState,
  reducers: {
    setData(state, action) {
      for (const key in action.payload) {
        if (Object.hasOwnProperty.call(action.payload, key)) {
          state[key] = action.payload[key];
        }
      }
    },
    valdiateStep1(state, action) {
      state.step1Validated = action.payload ?? true;
      state.activeTab = 1;
    },
    valdiateStep2(state) {
      state.step2Validated = true;
      state.activeTab = 2;
    },
    valdiateStep3(state) {
      state.step2Validated = true;
    },
    setActiveTab(state, action) {
      state.activeTab = action.payload;
    },
    restForm(state) {
      return initialState;
    },
    batchCreationFailure(state, action) {
      state.success = false;
      state.error = action.payload;
    },
    batchCreationSuccess(state, action) {
      state.success = action.payload;
    },
    setAllTrainees(state, action) {
      action.payload.map((elem) => {
        elem['checked'] = false;
      });
      state.allAvailableTrainees = action.payload;
    },
    selectTrainee(state, action) {
      const index = state.batchTrainees.findIndex((item) => item === action.payload.employeeId);
      if (index === -1) {
        state.batchTrainees.push(action.payload.employeeId);
      } else {
        state.batchTrainees = state.batchTrainees.filter(
          (item) => item !== action.payload.employeeId
        );
      }
    },
    handleSelectAll(state, action) {
      if (action.payload) {
        action.payload.forEach((item) => {
          state.batchTrainees.push(item.employeeId);
        });
      } else {
        state.allAvailableTrainees.forEach((item) => {
          state.batchTrainees.push(item.employeeId);
        });
      }
    },
    handleRemoveAll(state) {
      state.batchTrainees = [];
    },
    addEmployeesFromTable(state, action) {
      const newEmployees = action.payload.filter((id) => !state.batchTrainees.includes(id));
      state.batchTrainees = [...state.batchTrainees, ...newEmployees];
    },
    removeEmployeesFromTable(state, action) {
      state.batchTrainees = state.batchTrainees.filter((id) => !action.payload.includes(id));
    },
    setEmailConfig: (state, action) => {
      state.emailConfig = action.payload;
    },
    setUpdatedLogDocumentId(state, action) {
      state.updatedLogDocumentId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRegions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRegions.fulfilled, (state, action) => {
        state.loading = false;
        let regions = [];
        action.payload?.data?.regions.forEach((elem) => {
          regions.push({
            id: elem.regionId,
            label: elem.regionName,
          });
        });
        state.availableRegions = regions;
      })
      .addCase(fetchRegions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchBatchData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBatchData.fulfilled, (state, action) => {
        state.loading = false;
        const batchData = action.payload;
        state.batchId = batchData?.batchId || '';
        state.trainingType = batchData?.trainingType || '';
        state.dates = batchData?.dates || [];
        state.datesEnd = batchData?.datesEnd || [];
        state.ho = batchData?.ho || null;
        state.region = batchData?.region || [];
        state.batchType = batchData?.batchType || '';
        state.duration = batchData?.duration || '';
        state.description = batchData?.description || '';
        state.address = batchData?.address || '';
        state.venue = batchData?.venue || '';
        state.trainingLink = batchData?.trainingLink || '';
        state.active = batchData?.active || false;
        state.batchTrainees = [...(batchData?.batchTrainees ?? [])];
        state.branch = batchData?.branch || [];
        state.success = true;
        state.updating = true;
        state.googleMapsLink = batchData?.googleMapsLink || '';
        state.isApproved = batchData?.isApproved || false;
        state.trainingRoLocation = batchData?.trainingRoLocation || null;
        state.emailConfig = batchData?.emailConfig || {
          totalSteps: 3,
          steps: [
            { to: [], cc: [] },
            { to: [], cc: [] },
            { to: [], cc: [] },
          ],
        };
      })
      .addCase(fetchBatchData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(fetchDailyEmployeesWhoJoined.pending, (state) => {
        state.loadingPendecy = true;
        state.error = null;
        state.loading = true;
      })
      .addCase(fetchDailyEmployeesWhoJoined.fulfilled, (state, action) => {
        state.loadingPendecy = false;
        state.loading = false;

        console.log('in thunk', action.payload, action.payload.employees);
        let newEmployees = [];
        if (action.payload?.employees.length > 0) {
          newEmployees = action.payload.employees.map((employee) => ({
            ...employee,
            checked: false,
          }));
        }

        const currentlyAssignedEmployees = [];
        // console.log("currentlyAssignedBatchEmployees",JSON.stringify(action.payload.currentlyAssignedBatchEmployees))
        if (
          action.payload.currentlyAssignedBatchEmployees &&
          action.payload.currentlyAssignedBatchEmployees.length > 0
        ) {
          action.payload?.currentlyAssignedBatchEmployees.forEach((emp, idx) => {
            let tempEmp = { ...emp };
            tempEmp['checked'] = false;
            currentlyAssignedEmployees.push(tempEmp);
          });

          console.log('currentlyAssignedEmployees', currentlyAssignedEmployees);
        }

        console.log('newEmployees', currentlyAssignedEmployees, newEmployees);

        state.allAvailableTrainees = [...newEmployees];
        state.currentlyAssignedTrainees = [...currentlyAssignedEmployees];
      })
      .addCase(fetchDailyEmployeesWhoJoined.rejected, (state, action) => {
        // state.loadingPendecy = false;
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const {
  setData,
  valdiateStep1,
  valdiateStep2,
  valdiateStep3,
  restForm,
  setActiveTab,
  batchCreationSuccess,
  batchCreationFailure,
  setAllTrainees,
  selectTrainee,
  handleSelectAll,
  handleRemoveAll,
  addEmployeesFromTable,
  removeEmployeesFromTable,
  setEmailConfig,
  setUpdatedLogDocumentId,
} = trainingSlice.actions;

export const deleteBatch = createAsyncThunk(
  'training/deleteBatch',
  async ({ batchId, reason }, { rejectWithValue }) => {
    try {
      const response = await rootAxios.post('/super-user/delete-batch', { batchId, reason });
      console.log('Delete response:', response); // Add this for debugging
      if (response?.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response?.data?.message || 'Failed to delete batch');
      }
    } catch (error) {
      console.error('Delete batch error:', error);
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to delete batch'
      );
    }
  }
);

export default trainingSlice.reducer;
